import React from 'react'
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaAddressCard } from "react-icons/fa";
import {
  Section,
  Container,
  Grid,
  LeftSection,
  ImageContainer,
  Image,
  Overlay,
  Card,
  ContactLink,
  ContactText,
  RightSection,
  Heading,
  Input,
  TextArea,
  PrivacyContainer,
  Checkbox,
  PrivacyText,
  PrivacyLink,
  SubmitButton,
} from '../styles/ContactUsSectionStyles'

const ContactUsSection = () => {
  return (

    <Section>
      <Container>
        <Grid>
          {/* Left Section */}
          <LeftSection>
            <ImageContainer>
              <Image
                src="/assets/images/contactus.jpg"
                alt="ContactUs Tailwind Section"
              />
              <Overlay>
                <Card>
                  <ContactLink href="#home">
                    
                      <FaPhoneAlt />
                    
                    <ContactText>123-456-7890</ContactText>
                  </ContactLink>
                  <ContactLink href="#home">
                    
                      <MdEmail />
                    
                    <ContactText>sophia@sophiamatthew.com</ContactText>
                  </ContactLink>
                  <ContactLink href="#home">
                    <FaAddressCard/>
                    <ContactText>
                      11911 San Vicente Blvd. Suite 330,
                      <br />
                      Los Angeles, CA 90049
                    </ContactText>
                  </ContactLink>
                </Card>
              </Overlay>
            </ImageContainer>
          </LeftSection>

          {/* Right Section */}
          <RightSection>
            <Heading>Get In Touch</Heading>
            <Input type="text" placeholder="Name" />
            <Input type="email" placeholder="Email" />
            <TextArea placeholder="Your Message"></TextArea>
            <PrivacyContainer>
              <Checkbox type="checkbox" id="privacyPolicy" />
              <PrivacyText htmlFor="privacyPolicy">
                By providing Sophia Matthew Group your contact information, you
                acknowledge and agree to our{' '}
                <PrivacyLink href="#home">Privacy Policy</PrivacyLink> and
                consent to receiving marketing communications...
              </PrivacyText>
            </PrivacyContainer>
            <SubmitButton>Submit</SubmitButton>
          </RightSection>
        </Grid>
      </Container>
    </Section>

  )
}

export default ContactUsSection